import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import 'rc-collapse/assets/index.css';
import classNames from 'classnames';
import Context from '../context2.0';


class QAItem extends Component {


	constructor(props) {
		super(props);
		this.state = {
			selectedItemIndex: null
		}
	}

	handleContextOnClick(index) {
		this.setState({
			selectedItemIndex: index
		})
	}

	renderQuestions(questions, label) {
		return (<>
			<div className="question-panel-title">{label}</div>
			<div className="question-panel-content">
				<div className="audio-questions">
					{
						questions.map((item, index) => {
							let audio = item.audio;
							return (
								<Context key={index} className={"audio-question-item"} audio={audio} script={item.script} label={"Question"}/>
							)
						})
					}
				</div>
			</div>
		</>);
	}


	renderPossibleAnswers(possibleAnswers, label) {
		return (
			<>
				<div className="question-panel-title">{label}</div>
				<div className="question-panel-content">
					<div className="audio-questions">
						{
							possibleAnswers.map((item, index) => {
								let audio = item.audio;
								return (
									<Context key={index} className={"audio-question-item"} audio={audio} script={item.script} label={"Possible Answer"}/>
								)
							})
						}
					</div>
				</div>
			</>);
	}


	renderProblematicAnswers(problematicAnswers, label) {
		return (
			<>
			<div className="question-panel-title">Problematic Answers</div>
				<div className="question-panel-content">
					<div className="problematic-questions">
					{
						problematicAnswers.map((item, index) => {
							let probAnswerAudio = item.probAnswer.audio;
							let commentAudio = item.comment.audio;
							return (
								<div  key={index} className="problematic-question-item">
									<div className="question-item-number">{index+1}</div>
									<Context audio={probAnswerAudio} script={item.probAnswer.script} showingLabel label={"Variation"}/>
									<Context audio={commentAudio} script={item.comment.script} showingLabel label={"Comment"}/>
								</div>
							)
						})
					}
					</div>
				</div>
			</>
		);
	}

	render() {
		const {className, items, label, type} = this.props;
		const groupCls = classNames("question-panel", className);
		if(items){
			return (
				<div className={groupCls}>
					{
						type === "question" && this.renderQuestions(items, label)
					}
					{
						type === "possibleAnswer" && this.renderPossibleAnswers(items, label)
					}
					{
						type === "problematicAnswer" && this.renderProblematicAnswers(items, label)
					}
				</div>
			);
		}
		else{
			return (
				<div>Empty</div>
			)
		}

	}
}


QAItem.propTypes = {
	items: PropTypes.array.isRequired,
	label: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired
};


export default QAItem;